//@ts-expect-error missing types
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AppContainer = ({
  children
}) => /*#__PURE__*/_jsxs("main", {
  children: [/*#__PURE__*/_jsx(NotificationList, {}), children]
});
export default AppContainer;